import PropTypes from "prop-types";
import classNames from "classnames";
import { Button } from "components/Button";
import { successIcon } from "assets/icons";
import { SuccessModalContainer } from "./SuccessModal.styles";

export const SuccessModal = ({
  show = "true",
  onHide,
  text = "",
  icon = successIcon,
  className = "",
  description = "",
  iconClasses = "",
  btnText = "Ok",
  onSuccess = () => {},
}) => {
  const handleOkClick = () => {
    if (onSuccess) {
      onSuccess();
    }
    onHide();
  };

  return (
    <SuccessModalContainer
      heading=""
      show={show}
      onHide={onHide}
      className={className}
    >
      <div>
        <div className="logo-img">
          <img
            src={icon || successIcon}
            className={classNames("img", iconClasses)}
          />
        </div>
        <div className="heading-space pt-2">
          <h3 className="heading">{text}</h3>
          {description && <p className="description">{description}</p>}
        </div>
        <div className="btn-space">
          <Button onClick={handleOkClick} label={btnText} className="btn-ok" />
        </div>
      </div>
    </SuccessModalContainer>
  );
};

SuccessModal.propTypes = {
  show: PropTypes.bool,
  onHide: PropTypes.func,
  text: PropTypes.string,
  icon: PropTypes.string,
  className: PropTypes.string,
  description: PropTypes.string,
  iconClasses: PropTypes.string,
  btnText: PropTypes.string,
  onSuccess: PropTypes.func,
};

SuccessModal.displayName = "SuccessModal";
